import { Link } from "react-router-dom";
import { useSiteSettings, waLink } from "@/context/SiteSettingsContext";
import { useAppearance, siteImg } from "@/context/AppearanceContext";
import { SiteLogo } from "@/components/SiteLogo";

export const Header = () => {
  const { support_wa } = useSiteSettings();
  const { logo_horizontal } = useAppearance();
  return (
  <header
    className="sticky top-0 z-50 border-b border-[#2a2414] bg-[#0b0b0b]/95 backdrop-blur"
    data-testid="site-header"
  >
    <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-2.5 sm:px-6">
      <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
        {logo_horizontal ? (
          <img src={siteImg(logo_horizontal)} alt="JP STORE" className="h-10 w-auto max-w-[180px] object-contain sm:h-12" data-testid="header-logo" />
        ) : (
          <>
            <SiteLogo className="h-10 w-10 object-contain sm:h-12 sm:w-12" testid="header-logo" />
            <span className="kz-display text-base text-white sm:text-lg">JP STORE</span>
          </>
        )}
      </Link>
      <a
        href={waLink(support_wa, "Halo Admin JP STORE, saya ingin komplain transaksi.")}
        target="_blank"
        rel="noopener noreferrer"
        className="kz-gold-btn rounded-full px-4 py-2 text-[10px] font-extrabold uppercase tracking-wide text-black sm:px-6 sm:py-2.5 sm:text-xs"
        data-testid="header-admin-komplain"
      >
        Admin Khusus Komplain
      </a>
    </div>
  </header>
  );
};
